import $ from 'jquery';
import hotkeys from 'hotkeys-js';
import SelectService from '../service/SelectService';

// single select - select value
$('body').on('click', '.control-select--single .control-select-option', function () {
    if ($(this).hasClass('control-select-option--selected')) {
        return;
    }

    const id = $(this).parents('.control').attr('data-id');
    const value = $(this).attr('data-value');
    SelectService.setValue(id, value);
    SelectService.hide();
});

// multiple select value
$('body').on('click', '.control-select--multiple .control-select-option', function () {
    const id = $(this).parents('.control').attr('data-id');
    const isSelected = $(this).hasClass('control-select-option--selected');
    const optionValue = $(this).attr('data-value');
    let value = SelectService.getValue(id);

    if (!!value) {
        try {
            value = value ? JSON.parse(value) : [];
        } catch (e) {
            value = [];
        }
    } else {
        value = [];
    }

    if (isSelected) {
        value = value.filter(val => val != optionValue);
    } else {
        value.push(optionValue);
    }

    SelectService.setValue(id, value.length > 0 ? value : false);
});


// remove value
$('body').on('click', '.control-select-remove', function () {
    const id = $(this).parents('.control').attr('data-id');
    SelectService.setValue(id, false);
    SelectService.hide();
});

// select show
$('body').on('click', '.control-select-body__text', function () {
    $('.control-select').removeClass('control-select--opened');
    $(this).parents('.control-select').addClass('control-select--opened');
});

$('.control-select-search__field').keyup(function () {
    const val = $(this).val().toLowerCase();
    const options = $(this).parents('.control-select').find('.control-select-option');
    options.each(function () {
        const valid = $(this).text().trim().toLowerCase().indexOf(val) > -1;
        if (valid) {
            $(this).removeClass('hidden');
        } else {
            $(this).addClass('hidden');
        }
    });
});

// close on window  click
$(window).click((event) => {
    const target = $(event.target);
    if (!target.closest('.control-select').length) {
        SelectService.hide();
    }
});

// close on esc click
hotkeys('esc', () => {
    SelectService.hide();
});
